import { FinancialDocument } from "../../common/types/financialDocument";
import { IntegrationAccount } from "../../common/types/integrationAccount";

export enum ImporterDocumentImportStatus {
    SCHEDULED = "SCHEDULED",
    IN_PROGRESS = "IN_PROGRESS",
    FINISHED = "FINISHED",
}

export interface ImporterDocumentRow {
    id: string;
    file?: File;
    financialDocument?: FinancialDocument;
    integrationAccount?: IntegrationAccount;
    importStatus?: ImporterDocumentImportStatus;
}

export interface ImporterSheetTransaction {
    date: string;
    description: string;
    amount: number;
}
